export default __webpack_public_path__ + "static/media/bike_image3.ea70f7c8.jfif";